import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AddEditPartner } from '../components/features/partners/add-edit-partner/add-edit-partner';

export const canDeactivatePartnerGuard: CanDeactivateFn<AddEditPartner> = (component) => {
  const confirmationService = inject(ConfirmationService);
  const translateService = inject(TranslateService);

  // Check if form has unsaved changes
  const hasUnsavedChanges = component.partnerForm.dirty && !component.isPartnerSaved;

  if (!hasUnsavedChanges) {
    return true;
  }

  return new Promise<boolean>((resolve) => {
    confirmationService.confirm({
      message: translateService.instant('partner.guard.message'),
      header: translateService.instant('partner.guard.header'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: translateService.instant('partner.guard.accept'),
      rejectLabel: translateService.instant('partner.guard.reject'),
      accept: async () => {
        // Delete uploaded logo if exists
        await component.cleanupOnCancel();
        resolve(true);
      },
      reject: () => {
        resolve(false);
      }
    });
  });
};
